import { OnInit, Optional, Inject, ViewChild, ChangeDetectorRef, AfterViewChecked, Component, Input } from '@angular/core';
import { PershingTranslationService, IAuthorizationService, IAppDataStore } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { BalancesResponse, Balances, BalancesSummary, BalancesDetails, Mortgages, Loans } from '../../model/index';
import { BalancesLabels } from '../../i18n/balances-labels';
import { MatDialog } from '@angular/material/dialog';
import { TaxReclaimReceivablesComponent } from '../tax-reclaim-receivables/tax-reclaim-receivables.component';
import { BalancesConstants } from '../../utils/balances-constants';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { PageConfig, Summary } from '@pershing/nxi-common';


@Component({
    selector: 'modern-theme-balances-summary',
    templateUrl: './balances-summary.component.html'
})
export class BalancesSummaryComponent implements OnInit, AfterViewChecked {
    @Input() isSummaryView;
    header: string = '';
    isAllAccount: boolean = false;
    theme: string = 'standard';
    isLoading: boolean = true;
    balancesServiceErrorSub: any;
    trend: string = '';
    balancesResponseSub: any;
    balancesResponseErrorSub: any;
    fetchingBalancesDataSub: any;
    balancesResponse: BalancesResponse;
    balancesData: Balances;
    balancesDataSummary: BalancesSummary;
    balancesDataDetails: BalancesDetails;
    isCustodian: boolean = false;
    summaryLineItems: any = [];
    deviceType: string = '';
    isMarginEnabled: boolean = true;
    isGroup: boolean = false;
    isMixedGroup: boolean = false;
    BEMsg: string = 'BackEnd message Type [E|I] exists';
    SystemErrorMsg: string;
    entitledForWithdraw: boolean = true;
    dayTradingBuyingPowerEnable: boolean = true;
    entitledForLiabilities: boolean = false;
    entitledForTaxReclaimReceivables: boolean = false;
    liabilityData: any = [];
    showDelayedQuoteLegend: boolean = true;
    showDelayedQuoteLegendSub: any;
    defaultValue: any = 0;
    CustodianSingleAccount: boolean = false;
    brokerageSingleAccount: boolean = false;
    totalAcctValue: any;
    totalAcctDifference: any;
    totalAcctPercentage: any;
    longMarketValue: any;
    cashAvble: any;
    annuities: any;
    currentCashAvble: any;
    fundsAvailableToWithdraw: any;
    fundsAvailableToTrade: any;
    prevTaxReclaimTxt: any;
    marginableEquity: any;
    dayTradingBuyingPower: any;
    fundsDue: any;
    availableTrade: boolean = true;
    marketValue: boolean = true;
    view: string;
    longMarket: boolean = true;
    cashinfo: boolean = true;
    annuitiesInfo: boolean = true;
    asofTime: any;
    totalWorthDifference: any;
    totalWorthPercent: any;
    //download excel
    totalRowCount: number = 2;
    gridBalancesExport: any;
    downloadExtension: string = '';
    mortgagesData: Mortgages;
    loansData: Loans;
    data: any;
    mortgagesDataGrid: any;
    loansDataGrid: any;
    loansnadmortgageGrid: any;
    asOfDate: string = new Date().toISOString();
    withAnim: boolean = true;
    resetAnim: boolean = true;
    displayToggle: boolean;
    displayContainer: any;
    showSummaryLine: boolean= true;
    public carouselItems: any = [];
    carouselData: any = [];
    @ViewChild('myCarousel', { static: false }) myCarousel: NguCarousel;
    carouselConfig: NguCarouselConfig = {
        grid: { xs: 3, sm: 3, md: 4, lg: 4, all: 0 },
        point: {
        visible: true,
        hideOnSingleSlide: true
        },
        loop: true,
        touch: false,
        velocity: 0.2,
        easing: 'ease'
      }
      public static isCustodianUtil: boolean = false;
      public static isMixedGroupUtil: boolean = false
      public static disMarginEnabledUtil: boolean = false;
      longmarketval: any;
      roleStore: any;
      pageConfig: PageConfig;
      public summary: Summary[] = [];
    allAccountList: any;
    selectedAccountNumber: string;
    isAccountGroup: boolean = false;
    accountNumber: string;

    constructor(
        private translationService: PershingTranslationService,
        public appDataStore: IAppDataStore,
        private balancesService: BalancesService,
        private authorizationService: IAuthorizationService,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
    }

    ngOnInit() {
        this.pageConfig = {
            clickOptions: {
              enable: false,
              arrow: true
            },
            tilesPerResolution: {
              xSmall: 1,
              small: 3,
              medium: 3,
              large: 4,
              xLarge: 4
            },
            enableIndicators: {
              small: true,
              medium: true,
              large: false
            }
          }
        if (this.balancesService.subsVar === undefined) {
            this.balancesService.subsVar = this.balancesService.
            displayToggleEmitter.subscribe((name: string) => {
            this.setDisplayToggle();
            });
        }      
        this.roleStore = this.authorizationService['roleStore'] !== null;
        this.entitledForWithdraw = this.roleStore && this.authorizationService.isEntitled('HIDE_FUNDS_AVAIL_FOR_WITHDRAWAL') ?
            this.authorizationService.isEntitled('HIDE_FUNDS_AVAIL_FOR_WITHDRAWAL') : true;
        this.dayTradingBuyingPowerEnable = this.roleStore && this.authorizationService.isEntitled('DAY_TRADING_BUYING_POWER') ?
            this.authorizationService.isEntitled('DAY_TRADING_BUYING_POWER') : true;
        // Generic, http error e.g. 500.
        this.balancesServiceErrorSub = this.balancesService.balancesServiceError$.subscribe(error => {
            if(error) {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
            }
        });

        // Got BalancesResponse but has 'errorCode' of non-zero.
        this.balancesResponseErrorSub = this.balancesService.balancesResponseError$.subscribe(error => {
            if(error) {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
            }
        });

        // loading
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });

        this.balancesResponseSub = this.balancesService.balancesResponse$.subscribe(data => {
            if (!!data && !!data.response) {
                this.processBalancesData(data);
                this.balancesService.fetchingBalancesData$.next(false);
            }
        });

        this.showDelayedQuoteLegendSub = this.balancesService.realtimeQuote$.subscribe(realtime => {
            this.showDelayedQuoteLegend = !realtime;
        });
    }

    processBalancesData(data: BalancesResponse) {
        if (!!data && !!data.response) {
            this.balancesResponse = data;
            this.selectedAccountNumber = data.response.entity.id;
            if(data.response.entity.context === "group") {
                this.isAccountGroup = true;
                this.accountNumber = this.selectedAccountNumber.split(':')[1].split('_C')[0];
            } else {
                this.isAccountGroup = false;
                this.accountNumber = this.selectedAccountNumber;
            }
            this.marginEnabledView(this.accountNumber,this.isAccountGroup);
            this.balancesData = data.response.balances;
            this.balancesDataSummary = data.response.balances.balancesSummary;
            this.balancesDataDetails = data.response.balances.balancesDetails;
            this.isGroup = this.balancesService.displayParams$.isGroup;
            this.isMixedGroup = this.balancesService.displayParams$.isMixedGroup;
            this.isCustodian = this.balancesService.displayParams$.isCustodian;
            BalancesSummaryComponent.isCustodianUtil = this.balancesService.displayParams$.isCustodian;
            BalancesSummaryComponent.isMixedGroupUtil = this.balancesService.displayParams$.isMixedGroup;
            this.resolveBalancesDetailsView();
            let bd = this.balancesDataDetails
            let bs = this.balancesDataSummary
            this.totalAcctValue = bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue;
            this.totalAcctDifference = bs.totalWorth.difference ? bs.totalWorth.difference : this.defaultValue;
            this.totalAcctPercentage = bs.totalWorth.percentChange ? bs.totalWorth.percentChange : 0;
            this.fundsAvailableToWithdraw = bs.fundsAvailableToWithdraw ? bs.fundsAvailableToWithdraw : this.defaultValue;
            this.fundsAvailableToTrade = bs.fundsAvailableToTrade ? bs.fundsAvailableToTrade : this.defaultValue;
            this.marginableEquity =  bd.marginableEquity ? bd.marginableEquity : this.defaultValue;
            if (this.marginableEquity !== 0) {
                BalancesSummaryComponent.disMarginEnabledUtil = true;
            } else {
                BalancesSummaryComponent.disMarginEnabledUtil = false;
            }
            this.dayTradingBuyingPower = bd.dayTradeMarginableEquity ? bd.dayTradeMarginableEquity : this.defaultValue;
            this.fundsDue = bs.fundsDue ? bs.fundsDue : this.defaultValue;
            this.cashAvble = bd.cash.value ? bd.cash.value : this.defaultValue;
            this.annuities = bd.annuities.value ? bd.annuities.value : this.defaultValue;
            this.prevTaxReclaimTxt = bd.taxReclaim ? bd.taxReclaim : this.defaultValue;
            this.currentCashAvble = this.defaultValue;
            this.longMarketValue = bd.longMarketValue.value ? bd.longMarketValue.value : this.defaultValue;
            let time = data.response.balances.asOfDate != null ? data.response.balances.asOfDate.split('T')[1]:"";
            let timeSplitUp = time.split(':');
            let zone = parseInt(timeSplitUp[0]) >= 12 ?'PM':'AM';
            timeSplitUp[0] = parseInt(timeSplitUp[0]) > 12 ? (parseInt(timeSplitUp[0]) - 12) + '' : timeSplitUp[0];
            timeSplitUp[0] = parseInt(timeSplitUp[0]) == 0 ? '12' : timeSplitUp[0];
            this.asofTime = timeSplitUp[0] + ':' + timeSplitUp[1] + ' '+ zone  + ' '+ 'EST';
            this.isLoading = false;
            this.entitledForTaxReclaimReceivables = this.roleStore && this.authorizationService.isEntitled('VIEW_TAX_RECLAIM_RECEIVABLES') ?
            this.authorizationService.isEntitled('VIEW_TAX_RECLAIM_RECEIVABLES') : true;
            this.isAllAccount = this.balancesService.getIfAllAccount();
            this.entitledForTaxReclaimReceivables = this.entitledForTaxReclaimReceivables && !this.isAllAccount;
            this.totalWorthDifference = bs.totalWorth.difference == null || bs.totalWorth.difference == undefined ? 0 : bs.totalWorth.difference;
            if (this.totalWorthDifference < 0) {
                this.translationService.get('SUMMARY.down').subscribe(downData => this.trend = downData);
            } else if (this.totalWorthDifference == 0) {
                this.translationService.get('SUMMARY.noChg').subscribe(noChgData => this.trend = noChgData);
            } else {
                this.translationService.get('SUMMARY.up').subscribe(upData => this.trend = upData);
            }
            this.totalWorthPercent = bs.totalWorth.percentChange == null || bs.totalWorth.percentChange == undefined ? 0 : bs.totalWorth.percentChange;
            if( !!this.isCustodian && !this.isMixedGroup) {
                this.longmarketval = this.translationService.translate.instant('BALANCES.LONGMARKET');
            } else if (!!this.isMixedGroup && !!this.isCustodian) {
                this.longmarketval = this.translationService.translate.instant('BALANCES.LONGMARKETLONG');
            } else {
                this.longmarketval = this.translationService.translate.instant('BALANCES.LONGMARKETLONG');
            }
            this.getcarouselData();
            if (!this.isMixedGroup && this.isCustodian) {
                this.carouselItems = [
                    {
                        'key': 'BALANCES.MARKETVALUE',
                        'info': 'BALANCES.MARKETINFO',
                        'value': bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.LONGMARKET',
                        'info': 'BALANCES.LONGMARKETINFO',
                        'value': bd.longMarketValue.value ? bd.longMarketValue.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.CASH',
                        'info': 'BALANCES.CASHINFO',
                        'value': bd.cash.value ? bd.cash.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.ANNUITIES',
                        'info': 'BALANCES.ANNUITIESINFO',
                        'value': bd.annuities.value ? bd.cash.value : this.defaultValue
                    }];
                if(this.entitledForTaxReclaimReceivables){
                    this.carouselItems.push(
                        {
                            'key': 'BALANCES.TAXRECLAIMRECEIVABLES',
                            'info': 'BALANCES.TAXRECLAIMRECEIVABLESINFO',
                            'value': bd.taxReclaim ? bd.taxReclaim : this.defaultValue
                        }
                    );
                }
            } else if(!this.isMixedGroup && !this.isCustodian){
               this.carouselItems = [
                {
                    'key': 'BALANCES.MARKETVALUE',
                    'info': 'BALANCES.MARKETINFO',
                    'value': bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue
                },
                {
                    'key': 'BALANCES.AVAILABLETOTRADE',
                    'info': 'BALANCES.AVAILABLETOTRADEINFO',
                    'value': bs.fundsAvailableToTrade ? bs.fundsAvailableToTrade : this.defaultValue,
                     legend: this.balancesService.updateDisclaimer({
                        'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_FUNDSAVAILTOTRADE,
                        'show': true, 'className': 'fundsAvailToTrade', 'showCounter': 0
                    })

                },
                {
                    'key': 'BALANCES.BUYINGPOWER',
                    'info': 'BALANCES.BUYINGPOWERINFO',
                    'value': (this.isGroup || this.isMixedGroup) ? (bd.dayTradingBuyingPower.value ? bd.dayTradingBuyingPower.value: this.defaultValue) : (bd.dayTradingBuyingPowerPrevClose ? bd.dayTradingBuyingPowerPrevClose : this.defaultValue)
                },
                {
                    'key': 'BALANCES.FUNDSDUE',
                    'info': 'BALANCES.FUNDSDUEINFO',
                    'value': bs.fundsDue ? bs.fundsDue : this.defaultValue,
                     legend: this.balancesService.updateDisclaimer({
                        'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CALCULATEDFUNDSDUE,
                        'show': true, 'className': 'calculatedFundsDue', 'showCounter': 0
                    })
                }];
                if(this.isMarginEnabled) {
                    this.carouselItems.push(
                        {
                            'key': 'BALANCES.AVAILABLETOTRADEMARGIN',
                            'info': 'BALANCES.AVAILABLETOTRADEMARGININFO',
                            'value': bd.marginableEquity ? bd.marginableEquity : this.defaultValue
                        }
                    )
                }
                if(this.entitledForWithdraw){
                    this.carouselItems.push(
                        {
                            'key': 'BALANCES.AVAILABLECASH',
                            'info': 'BALANCES.AVAILABLECASHINFO',
                            'value': bs.fundsAvailableToWithdraw ? bs.fundsAvailableToWithdraw : this.defaultValue
                        }
                    );
                }
            }
            if(this.entitledForLiabilities){
                this.carouselItems.push(
                    {
                        'key': 'BALANCES.LOANAMTOUTSTD',
                        'info': 'BALANCES.LOANAMTOUTSTDINFO',
                        'value': this.defaultValue
                    }
                );
                this.carouselItems.push(
                    {
                        'key': 'BALANCES.LOANAVALCASH',
                        'info': 'BALANCES.LOANAVALCASHINFO',
                        'value': this.defaultValue
                    }
                );
            }           
        }
    }
    marginEnabledView(accountNumber,isAccountGroup) {
        if(this.appDataStore.get("ACCOUNTS_LIST") != null){
            this.allAccountList = this.appDataStore.get("ACCOUNTS_LIST");
            for (let i = 0; i < this.allAccountList.length; i++) {
                    if (!isAccountGroup && this.allAccountList[i].acctNo === accountNumber) {
                        this.isMarginEnabled = this.allAccountList[i].marginEnabled;
                        break;
                } else if (this.allAccountList[i].groupDesc === accountNumber) {
                        this.isMarginEnabled = this.allAccountList[i].marginEnabled;
                        break;
                    }
            }
        }
    }
    getcarouselData() {
        this.carouselData = [];
        if(this.view === 'brokerage') {
            this.getBrokerageData();
        }
        if(this.view === 'custodian') {
            this.getCustodianData();
        }
        this.setTilesBorder();
        this.processCarouselData(this.carouselData);
    }
    getBrokerageData() {
        if(this.marketValue) {
            this.carouselData.push({'key': 'BALANCES.MARKETVALUE','info': 'BALANCES.MARKETINFO','value': this.totalAcctValue});
        }
        if(this.entitledForWithdraw) {
            this.carouselData.push({'key': 'BALANCES.AVAILABLECASH','info': 'BALANCES.AVAILABLECASHINFO','value': this.fundsAvailableToWithdraw});
        }
        if(this.availableTrade) {
            this.carouselData.push({'key': 'BALANCES.AVAILABLETOTRADE','info': 'BALANCES.AVAILABLETOTRADEINFO','value': this.fundsAvailableToTrade});
        }
        if(this.isMarginEnabled) {
             this.carouselData.push({'key': 'BALANCES.AVAILABLETOTRADEMARGIN','info': 'BALANCES.AVAILABLETOTRADEMARGININFO','value': this.marginableEquity});
        }
        if(this.dayTradingBuyingPowerEnable) {
            this.carouselData.push({'key': 'BALANCES.BUYINGPOWER','info': 'BALANCES.BUYINGPOWERINFO','value': this.dayTradingBuyingPower});
        }
        this.carouselData.push({'key': 'BALANCES.FUNDSDUE','info': 'BALANCES.FUNDSDUEINFO','value': this.fundsDue});
        if(this.entitledForLiabilities) {
            this.carouselData.push({'key': 'BALANCES.LOANAMTOUTSTD','info': 'BALANCES.LOANAMTOUTSTDINFO','value': this.currentCashAvble},
                                   {'key': 'BALANCES.LOANAVALCASH','info': 'BALANCES.LOANAVALCASHINFO','value': this.currentCashAvble});
        }
    }
    getCustodianData() {
        if(this.marketValue) {
            this.carouselData.push({'key': 'BALANCES.MARKETVALUE','info': 'BALANCES.MARKETINFO','value': this.totalAcctValue});
        }
        if(this.longMarket) {
            this.carouselData.push({'key': this.longmarketval,'info': 'BALANCES.LONGMARKETINFO','value': this.longMarketValue});
        }
        if(this.cashinfo) {
            this.carouselData.push({'key': 'BALANCES.CASH','info': 'BALANCES.CASHINFO','value': this.cashAvble});
        }
        if(this.annuitiesInfo) {
            this.carouselData.push({'key': 'BALANCES.ANNUITIES','info': 'BALANCES.ANNUITIESINFO','value': this.annuities});
        }
        if(this.entitledForTaxReclaimReceivables) {
            this.carouselData.push({'key': 'BALANCES.TAXRECLAIMRECEIVABLES','info': 'BALANCES.TAXRECLAIMRECEIVABLES','value': this.prevTaxReclaimTxt});
        }
        if(this.entitledForLiabilities) {
            this.carouselData.push({'key': 'BALANCES.LOANAMTOUTSTD','info': 'BALANCES.LOANAMTOUTSTDINFO','value': this.currentCashAvble},
                                   {'key': 'BALANCES.LOANAVALCASH','info': 'BALANCES.LOANAVALCASHINFO','value': this.currentCashAvble});
        }
    }

    processCarouselData(summaryArr) {
        this.summary = [];
        if(summaryArr) {
          let id = 0;
          summaryArr.forEach(tile => {
            let item = {
              id: id,
              borderColor: tile.highchartClass,
              props: tile,
            }
            this.summary.push(item);
            id++;
          });
          console.log("summary is =====",this.summary);
        }
    }

    setTilesBorder() {
        if(this.carouselData) {
            let index = 0;
            this.carouselData.forEach(element => {
                element.highchartClass = 'highcharts-color-' + index;
                index++;
            });
        }
    }
    resolveBalancesDetailsView() {
        if (this.isCustodian) {
            // For either single or grouped accounts that are custodian only.
            this.view = BalancesConstants.CUSTODIAN_VIEW;
        } else {
            // For either single or grouped accounts that are brokerage only.
            this.view = BalancesConstants.BROKERAGE_VIEW;
        }
    }
  clearBrokerageDisclaimers() {
        this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_FUNDSAVAILTOTRADE,
            'show': false, 'className': 'fundsAvailToTrade', 'showCounter': 0
        });
        this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CALCULATEDFUNDSDUE,
            'show': false, 'className': 'calculatedFundsDue', 'showCounter': 0
        });
    }

    taxReclaimReceivablesPopup() {
        this.dialog.open(TaxReclaimReceivablesComponent, { disableClose: true, panelClass: ['modal', 'bal-TaxReclaimReceivablesDialog']});
    }

    ngOnDestroy(): void {
        this.clearBrokerageDisclaimers();
        if (this.balancesServiceErrorSub) {
            this.balancesServiceErrorSub.unsubscribe();
        }
        if (this.balancesResponseErrorSub) {
            this.balancesResponseErrorSub.unsubscribe();
        }
        if (this.balancesResponseSub) {
            this.balancesResponseSub.unsubscribe();
        }
        if (this.fetchingBalancesDataSub) {
            this.fetchingBalancesDataSub.unsubscribe();
        }
        if (this.showDelayedQuoteLegendSub) {
            this.showDelayedQuoteLegendSub.unsubscribe();
        }
    }

    reset() {
        this.myCarousel.reset(!this.resetAnim);
    }

    moveTo(slide) {
        this.myCarousel.moveTo(slide, !this.withAnim);
    }
    ngAfterViewChecked() {
        this.cdr.detectChanges();
      }
      getLegend(key: string, show: boolean, className: string) {
        return this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': key,
            'show': show, 'className': className, 'showCounter': 0
        });
    }

    setDisplayToggle(){
        this.showSummaryLine = this.balancesService.getDisplayToggle();
    }
}
